"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CalculatorForm = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dayjs = _interopRequireDefault(require("dayjs"));

var _html2canvas = _interopRequireDefault(require("html2canvas"));

var _jspdf = require("jspdf");

var _loadingAnimations = require("./loadingAnimations");

var _IconBtnTooltip = _interopRequireDefault(require("../IconBtnTooltip"));

var _LoadingOverlay = _interopRequireDefault(require("../LoadingOverlay"));

var _material = require("@mui/material");

var _iconsMaterial = require("@mui/icons-material");

var _BracketsHeader = _interopRequireDefault(require("./components/BracketsHeader"));

var _Category = _interopRequireDefault(require("./components/Category"));

var _FormTotalsFoot = _interopRequireDefault(require("./components/FormTotalsFoot"));

var _StackedBarChart = _interopRequireDefault(require("./components/StackedBarChart"));

var _helpers = require("./helpers");

require("./Calculator.styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var errorMessageBracketTotals = function errorMessageBracketTotals(isStatic) {
  return isStatic ? 'The Total Allocation must equal 100%.' : 'The Total Allocations for each age bracket must equal 100%.';
};

var errorBracketTotalSumOver100 = 'The column total should not be more than 100%.';

var errorMessageBracketAllocation = function errorMessageBracketAllocation(fundName, maxAllocation) {
  return "The percentage for ".concat(fundName, " cannot exceed ").concat(maxAllocation, "%");
};

var errorMessageTemplateName = 'Template name has to be between 1 and 40 characters long.';

var CalculatorForm = /*#__PURE__*/function (_Component) {
  _inherits(CalculatorForm, _Component);

  var _super = _createSuper(CalculatorForm);

  function CalculatorForm() {
    var _this;

    _classCallCheck(this, CalculatorForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "printRef", /*#__PURE__*/_react["default"].createRef());

    _defineProperty(_assertThisInitialized(_this), "initializeCategoriesToShow", function (categories) {
      return categories.map(function () {
        return true;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "initializeMatrixAllocations", function (categories) {
      return categories.map(function (category) {
        return category.Funds.map(function (fund) {
          return fund.AgeBrackets.map(function (bracket) {
            var initValue = isNaN(parseFloat(bracket.Percentage)) || parseFloat(bracket.Percentage) === 0 ? '' : (0, _helpers.toFixed2)(bracket.Percentage);
            return initValue;
          });
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "initializeMatrixMaxAllocations", function (categories) {
      return categories.map(function (category) {
        return category.Funds.map(function (fund) {
          return fund.AgeBrackets.map(function () {
            return fund.MaximumAllocation;
          });
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "initializeCalculator", function (schema) {
      var _this$props = _this.props,
          isViewing = _this$props.isViewing,
          stickyHeaderTopOffset = _this$props.stickyHeaderTopOffset,
          isTemplateNameEditing = _this$props.isTemplateNameEditing;
      var isStatic = schema.TemplateType === 'S';
      var bracketNames = schema.FundCategories[0].Funds[0].AgeBrackets.map(function (bracket) {
        return bracket.BracketName;
      });

      var matrixAllocations = _this.initializeMatrixAllocations(schema.FundCategories); // initialize colors


      var categoryColors = schema.FundCategories.map(function (category) {
        return category.FundCategoryColor;
      }); // in case of editing all values need to be recalculated

      var categoriesSubtotals = matrixAllocations.map(function (funds) {
        return bracketNames.map(function (bracketName, bracketIndex) {
          return _this.getCategorySubtotalPerBracket(bracketIndex, funds);
        });
      });
      var bracketTotals = bracketNames.map(function (bracketName, bracketIndex) {
        return _this.getBracketTotal(bracketIndex, matrixAllocations, categoriesSubtotals);
      });
      var fundExpenseRatios = schema.FundCategories.map(function (category) {
        return category.Funds.map(function (fund) {
          return fund.FeeRate;
        });
      });

      var estFundFees = _this.estFundFeesCalculate(matrixAllocations, fundExpenseRatios, bracketNames);

      var my529AdminAssetFees = bracketNames.map(function () {
        return schema.AssetFeeRate * 100;
      });

      var estTotalFees = _this.estTotalFeesCalculate(estFundFees, my529AdminAssetFees, bracketNames);

      var hasFundsValues = matrixAllocations.map(function (funds) {
        return funds.map(function (brackets) {
          return Boolean(brackets.find(function (bracketValue) {
            return bracketValue > 0;
          }));
        });
      });
      var selectedFunds = matrixAllocations.map(function (funds, categoryIndex) {
        return funds.map(function (brackets, fundIndex) {
          return hasFundsValues[categoryIndex][fundIndex];
        });
      });

      var categoriesToShow = _this.initializeCategoriesToShow(schema.FundCategories); // initialize error messages


      var errorMessages = {
        hasAllocationAmountError: '',
        // assuming there are no bracket errors to start with
        hasAnyBracketTotalNot100Error: _this.getBracketsTotalsError(bracketTotals),
        // but calculating the total amounts errors in case of editing
        templateNameNot1To40CharsError: isTemplateNameEditing ? errorMessageTemplateName : '',
        // template value is empty to start with if template name is editing
        hasBracketTotalSumOver100Error: '' // starting with empty values or the correct ones from api

      }; // agreement year for foot notes

      var currentDate = (0, _dayjs["default"])(_this.props.currentDate); // if api date is missing defaults to the browser one

      var currentYear = currentDate.format('YYYY');
      var agreementYear = currentDate.isAfter("".concat(currentYear, "-02-28"), 'day') ? currentDate.add('1', 'year').format('YYYY') : currentYear; // calculate sticky headers offsets when age-based, static, or viewing

      var categoryStickyHeaderOffset = stickyHeaderTopOffset + 60;
      var subCategoryStickyHeaderOffset = categoryStickyHeaderOffset + (isViewing ? 27 : 36);

      _this.setState({
        categoryColors: categoryColors,
        templateName: '',
        wasSaveClicked: false,
        categoryStickyHeaderOffset: categoryStickyHeaderOffset,
        subCategoryStickyHeaderOffset: subCategoryStickyHeaderOffset,
        agreementYear: agreementYear,
        matrixAllocations: matrixAllocations,
        matrixMaxAllocations: _this.initializeMatrixMaxAllocations(schema.FundCategories),
        bracketTotals: bracketTotals,
        fundExpenseRatios: fundExpenseRatios,
        categoriesSubtotals: categoriesSubtotals,
        estFundFees: estFundFees,
        my529AdminAssetFees: my529AdminAssetFees,
        estTotalFees: estTotalFees,
        categoriesToShow: categoriesToShow,
        bracketErrorIndices: bracketNames.map(function () {
          return -1;
        }),
        // assuming there are no bracket errors to start with
        hasFundsValues: hasFundsValues,
        selectedFunds: selectedFunds,
        bracketNames: bracketNames,
        errorMessages: errorMessages,
        showSelectedFundsOnly: false,
        isStatic: isStatic,
        isInitializing: false,
        visibleFundIds: _this.getVisibleFundIdsForIndexing(false, selectedFunds, categoriesSubtotals, categoriesToShow)
      }); // send initial values and errors to a parent


      _this.props.onAllocationChange && _this.props.onAllocationChange(matrixAllocations, errorMessages);
    });

    _defineProperty(_assertThisInitialized(_this), "state", {
      categoryStickyHeaderOffset: 0,
      subCategoryStickyHeaderOffset: 0,
      matrixAllocations: [],
      templateName: '',
      matrixMaxAllocations: [],
      bracketNames: [],
      bracketTotals: [],
      fundExpenseRatios: [],
      estFundFees: [],
      estTotalFees: [],
      my529AdminAssetFees: [],
      categoriesSubtotals: [],
      categoriesToShow: [true],
      bracketErrorIndices: [],
      errorMessages: {
        hasAnyBracketTotalNot100Error: '',
        hasAllocationAmountError: '',
        templateNameNot1To40CharsError: '',
        hasBracketTotalSumOver100Error: ''
      },
      showSelectedFundsOnly: false,
      isStatic: true,
      hasFundsValues: [[false]],
      selectedFunds: [[false]],
      agreementYear: null,
      isInitializing: true,
      categoryColors: [],
      visibleFundIds: [],
      wasSaveClicked: false
    });

    _defineProperty(_assertThisInitialized(_this), "cumulativeOffset", function (element) {
      var top = 0;

      do {
        top += element.offsetTop || 0;
        element = element.offsetParent;
      } while (element);

      return top;
    });

    _defineProperty(_assertThisInitialized(_this), "isCategoryShowing", function (categoryIndex, categoriesSubtotals) {
      var categoryHas0Sum = categoriesSubtotals[categoryIndex].reduce(function (sum, bracketSum) {
        return sum += bracketSum;
      }, 0) === 0;
      var showCategory = !(_this.props.isViewing && categoryHas0Sum);
      return showCategory;
    });

    _defineProperty(_assertThisInitialized(_this), "getVisibleFundIdsForIndexing", function (showSelectedFundsOnly, selectedFunds, categoriesSubtotals, categoriesToShow) {
      var visibleFundIndex = 0;

      if (_this.props.isViewing) {
        // if we are viewing we want to show only funds as if Show Selected Funds only on
        showSelectedFundsOnly = true;
      }

      var visibleFundIds = selectedFunds.map(function (category, categoryIndex) {
        return category.map(function (isFundSelected) {
          var showCategory = _this.isCategoryShowing(categoryIndex, categoriesSubtotals) && categoriesToShow[categoryIndex];
          var showFund = showSelectedFundsOnly ? isFundSelected && showCategory : showCategory;

          if (showFund) {
            return visibleFundIndex++;
          } else {
            return -1;
          }
        });
      });
      return visibleFundIds;
    });

    _defineProperty(_assertThisInitialized(_this), "getVisibleFundIdsLength", function () {
      var visibleFundIds = _this.state.visibleFundIds;
      var length = 0;
      visibleFundIds.forEach(function (fundIds) {
        return fundIds.forEach(function (fundId) {
          if (fundId > -1) length++;
        });
      });
      return length;
    });

    _defineProperty(_assertThisInitialized(_this), "wasAnyFundSelected", function () {
      return _this.state.selectedFunds.find(function (category) {
        return category.find(function (wasFundSelected) {
          return wasFundSelected;
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getBracketError", function (categoryIndex, fundIndex, bracketIndex) {
      var bracketErrorIndices = _this.state.bracketErrorIndices;
      return categoryIndex === bracketErrorIndices[0] && fundIndex === bracketErrorIndices[1] && bracketIndex === bracketErrorIndices[2] && !bracketErrorIndices.includes(-1);
    });

    _defineProperty(_assertThisInitialized(_this), "getBracketsTotalsError", function (bracketTotals) {
      // check if any bracket total is less than 100 but more than 0
      var hasAnyBracketTotalNot100Error = bracketTotals.some(function (bracketTotal) {
        return parseFloat((0, _helpers.toFixed2)(bracketTotal)) !== 100;
      });
      return hasAnyBracketTotalNot100Error ? errorMessageBracketTotals(_this.state.isStatic) : '';
    });

    _defineProperty(_assertThisInitialized(_this), "validateMatrixAndGetErrors", function (value, categoryIndex, fundIndex, bracketIndex, bracketTotals) {
      var _this$state = _this.state,
          matrixMaxAllocations = _this$state.matrixMaxAllocations,
          errorMessages = _this$state.errorMessages;
      var FundCategories = _this.props.schema.FundCategories;
      value = parseFloat(value);
      var maxAllocation = matrixMaxAllocations[categoryIndex][fundIndex][bracketIndex];
      var fundName = FundCategories[categoryIndex].Funds[fundIndex].FundName; // check max allocation amount 

      var hasAllocationAmountError = value < 0 || value > maxAllocation; // check if the column sum is not over 100%

      var hasBracketTotalSumOver100Error = parseFloat((0, _helpers.toFixed2)(bracketTotals[bracketIndex])) > 100 ? errorBracketTotalSumOver100 : '';

      var updatedErrorMessages = _objectSpread(_objectSpread({}, errorMessages), {}, {
        // there might be from the template name validation
        hasAnyBracketTotalNot100Error: _this.getBracketsTotalsError(bracketTotals),
        hasAllocationAmountError: hasAllocationAmountError ? errorMessageBracketAllocation(fundName, maxAllocation) : '',
        hasBracketTotalSumOver100Error: hasBracketTotalSumOver100Error
      });

      var bracketErrorIndices = hasAllocationAmountError || hasBracketTotalSumOver100Error ? [categoryIndex, fundIndex, bracketIndex] : [-1, -1, -1];

      _this.setState({
        bracketErrorIndices: bracketErrorIndices
      });

      return updatedErrorMessages;
    });

    _defineProperty(_assertThisInitialized(_this), "getCategorySubtotalPerBracket", function (bracketIndex, funds) {
      return funds.reduce(function (sum, bracketValues) {
        var parsedValue = parseFloat(bracketValues[bracketIndex]);
        var bracketValue = isNaN(parsedValue) ? 0 : parsedValue;
        return sum + bracketValue;
      }, 0);
    });

    _defineProperty(_assertThisInitialized(_this), "updateAndGetCategoriesSubtotals", function (categoryIndex, bracketIndex, matrixAllocations, categoriesSubtotals) {
      categoriesSubtotals[categoryIndex][bracketIndex] = _this.getCategorySubtotalPerBracket(bracketIndex, matrixAllocations[categoryIndex]);
      return categoriesSubtotals;
    });

    _defineProperty(_assertThisInitialized(_this), "getBracketTotal", function (bracketIndex, matrixAllocations, categoriesSubtotals) {
      return matrixAllocations.reduce(function (sum, category, categoryIndex) {
        return sum + categoriesSubtotals[categoryIndex][bracketIndex];
      }, 0);
    });

    _defineProperty(_assertThisInitialized(_this), "updateAndGetBracketTotals", function (bracketIndex, matrixAllocations, categoriesSubtotals) {
      // reuse subtotal to calculate totals
      var updatedBracketTotals = _this.state.bracketTotals;
      updatedBracketTotals[bracketIndex] = _this.getBracketTotal(bracketIndex, matrixAllocations, categoriesSubtotals);
      return updatedBracketTotals;
    });

    _defineProperty(_assertThisInitialized(_this), "estTotalFeesCalculate", function (estFundFees, my529AdminAssetFees, bracketNames) {
      return bracketNames.map(function (bracket, idx) {
        return estFundFees[idx] + my529AdminAssetFees[idx];
      });
    });

    _defineProperty(_assertThisInitialized(_this), "resetCalculatorHandler", function () {
      var schema = _this.props.schema;
      var zeroedMatrixAllocations = schema.FundCategories.map(function (category) {
        return category.Funds.map(function (fund) {
          return fund.AgeBrackets.map(function () {
            return 0;
          });
        });
      });
      var zeroedSchema = (0, _helpers.populate3DCalculatorSchema)(zeroedMatrixAllocations, schema);

      _this.initializeCalculator(zeroedSchema);
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectedFundsToggleHandler", function (e, categories) {
      e && e.stopPropagation();
      var showSelectedFundsOnly = !_this.state.showSelectedFundsOnly; // let's expend all not user collapsed categories when toggling show selected categories off

      var categoriesToShow = !showSelectedFundsOnly ? _this.initializeCategoriesToShow(categories) : _this.state.categoriesToShow;

      _this.setState({
        showSelectedFundsOnly: showSelectedFundsOnly,
        visibleFundIds: _this.getVisibleFundIdsForIndexing(showSelectedFundsOnly, _this.state.selectedFunds, _this.state.categoriesSubtotals, categoriesToShow) // re-index ids of all input cells

      });
    });

    _defineProperty(_assertThisInitialized(_this), "onCategoryExpendToggleHandler", function (categoryIndex) {
      var updatedCategoriesToShow = _this.state.categoriesToShow;
      updatedCategoriesToShow[categoryIndex] = !updatedCategoriesToShow[categoryIndex];

      _this.setState({
        categoriesToShow: updatedCategoriesToShow,
        visibleFundIds: _this.getVisibleFundIdsForIndexing(_this.state.showSelectedFundsOnly, _this.state.selectedFunds, _this.state.categoriesSubtotals, updatedCategoriesToShow) // re-index ids of all input cells

      });
    });

    _defineProperty(_assertThisInitialized(_this), "onBracketBlurHandler", function (categoryIndex, fundIndex, bracketIndex) {
      var updatedMatrix = _this.state.matrixAllocations;

      if (_this.getBracketError(categoryIndex, fundIndex, bracketIndex) || isNaN(updatedMatrix[categoryIndex][fundIndex][bracketIndex])) {
        // reset bracket value to 0
        _this.onBracketValueChangeHandler(0, categoryIndex, fundIndex, bracketIndex);
      } else {
        // just remove trailing 0s
        // const valueNoTrailing0s = parseFloat(updatedMatrix[categoryIndex][fundIndex][bracketIndex]);
        var valueToFixed2 = (0, _helpers.toFixed2)(updatedMatrix[categoryIndex][fundIndex][bracketIndex]);
        var formattedIf0 = isNaN(valueToFixed2) || parseFloat(valueToFixed2) === 0 ? '' : valueToFixed2;

        _this.onBracketValueChangeHandler(formattedIf0, categoryIndex, fundIndex, bracketIndex);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onFundSelectionHandler", function (checked, categoryIndex, fundIndex) {
      var _this$state2 = _this.state,
          selectedFunds = _this$state2.selectedFunds,
          matrixAllocations = _this$state2.matrixAllocations,
          bracketNames = _this$state2.bracketNames,
          my529AdminAssetFees = _this$state2.my529AdminAssetFees;
      var schema = _this.props.schema;
      var showSelectedFundsOnly = _this.state.showSelectedFundsOnly;
      var updatedSelectedFunds = selectedFunds;
      var updatedMatrixAllocations = matrixAllocations;
      updatedSelectedFunds[categoryIndex][fundIndex] = checked; // reset fund row to 0s if unselected

      if (!checked) {
        _this.state.bracketNames.forEach(function (bracketName, bracketIndex) {
          return updatedMatrixAllocations[categoryIndex][fundIndex][bracketIndex] = 0;
        }); // recalculate sums


        var categoriesSubtotals = updatedMatrixAllocations.map(function (funds) {
          return bracketNames.map(function (bracketName, bracketIndex) {
            return _this.getCategorySubtotalPerBracket(bracketIndex, funds);
          });
        });
        var bracketTotals = bracketNames.map(function (bracketName, bracketIndex) {
          return _this.getBracketTotal(bracketIndex, updatedMatrixAllocations, categoriesSubtotals);
        });
        var fundExpenseRatios = schema.FundCategories.map(function (category) {
          return category.Funds.map(function (fund) {
            return fund.FeeRate;
          });
        });

        var estFundFees = _this.estFundFeesCalculate(updatedMatrixAllocations, fundExpenseRatios, bracketNames);

        var estTotalFees = _this.estTotalFeesCalculate(estFundFees, my529AdminAssetFees, bracketNames);

        var hasFundsValues = updatedMatrixAllocations.map(function (funds) {
          return funds.map(function (brackets) {
            return Boolean(brackets.find(function (bracketValue) {
              return bracketValue > 0;
            }));
          });
        });

        _this.setState({
          matrixAllocations: updatedMatrixAllocations,
          bracketTotals: bracketTotals,
          fundExpenseRatios: fundExpenseRatios,
          categoriesSubtotals: categoriesSubtotals,
          estFundFees: estFundFees,
          estTotalFees: estTotalFees,
          hasFundsValues: hasFundsValues,
          selectedFunds: updatedSelectedFunds
        }, function () {
          // also check if there are any allocations and if not disable show selected funds button and expand all funds
          !_this.wasAnyFundSelected() && showSelectedFundsOnly && _this.onSelectedFundsToggleHandler(null, schema.FundCategories);
        });
      } else {
        // just update selected funds
        _this.setState({
          selectedFunds: updatedSelectedFunds
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onTemplateNameChangeHandler", function (e) {
      var templateName = e.target.value;
      var onTemplateNameChange = _this.props.onTemplateNameChange; // check if template name is empty or more than 40 chars

      var updatedErrorMessages = _objectSpread({}, _this.state.errorMessages);

      updatedErrorMessages.templateNameNot1To40CharsError = _this.props.isTemplateNameEditing && (templateName.length === 0 || templateName.length > 40) ? errorMessageTemplateName : '';

      _this.setState({
        templateName: templateName,
        errorMessages: updatedErrorMessages
      }); // pass to the parent if it wants it


      onTemplateNameChange && onTemplateNameChange(templateName, updatedErrorMessages);
    });

    _defineProperty(_assertThisInitialized(_this), "onBracketValueChangeHandler", function (value, categoryIndex, fundIndex, bracketIndex) {
      var _this$state3 = _this.state,
          matrixAllocations = _this$state3.matrixAllocations,
          hasFundsValues = _this$state3.hasFundsValues,
          fundExpenseRatios = _this$state3.fundExpenseRatios,
          bracketNames = _this$state3.bracketNames,
          my529AdminAssetFees = _this$state3.my529AdminAssetFees,
          categoriesSubtotals = _this$state3.categoriesSubtotals;
      var onAllocationChange = _this.props.onAllocationChange;
      var updatedMatrix = matrixAllocations;
      var updatedSelectedFunds = hasFundsValues; // make sure it is a string since this method is also called outside of the input

      value = value.toString(); // allow only numbers and pointer

      value = value.replace(/[^0-9.]/g, '');
      var pointerIndex = value.indexOf('.');

      if (pointerIndex !== -1) {
        // remove any additional '.' 
        var strAfterDotCleaned = value.substring(pointerIndex + 1).replace(/\./g, '');
        value = value.substring(0, pointerIndex).concat('.', strAfterDotCleaned); // remove any decimals when more then 2

        value = value.substring(0, pointerIndex + 3);
      }

      updatedMatrix[categoryIndex][fundIndex][bracketIndex] = value;
      var checked = value > 0;
      updatedSelectedFunds[categoryIndex][fundIndex] = checked; // also update the checkbox

      checked && _this.onFundSelectionHandler(checked, categoryIndex, fundIndex); // recalculate expense ratios for each fund

      var updatedEstFundFees = _this.estFundFeesCalculate(updatedMatrix, fundExpenseRatios, bracketNames); // recalculate est total fees


      var updatedEstTotalFees = _this.estTotalFeesCalculate(updatedEstFundFees, my529AdminAssetFees, bracketNames); // recalculate subtotals for categories


      var updatedCategoriesSubtotals = _this.updateAndGetCategoriesSubtotals(categoryIndex, bracketIndex, updatedMatrix, categoriesSubtotals); // recalculate totals for all brackets


      var updatedBracketTotals = _this.updateAndGetBracketTotals(bracketIndex, updatedMatrix, updatedCategoriesSubtotals);

      var updatedErrorMessages = _this.validateMatrixAndGetErrors(value, categoryIndex, fundIndex, bracketIndex, updatedBracketTotals);

      _this.setState({
        matrixAllocations: updatedMatrix,
        hasFundsValues: updatedSelectedFunds,
        estFundFees: updatedEstFundFees,
        estTotalFees: updatedEstTotalFees,
        categoriesSubtotals: updatedCategoriesSubtotals,
        bracketTotals: updatedBracketTotals,
        errorMessages: updatedErrorMessages
      }); // pass to the parent if it wants it


      onAllocationChange && onAllocationChange(updatedMatrix, updatedErrorMessages);
    });

    _defineProperty(_assertThisInitialized(_this), "onBracketCopyHandler", function (bracketIndex) {
      var onAllocationChange = _this.props.onAllocationChange;
      var _this$state4 = _this.state,
          matrixAllocations = _this$state4.matrixAllocations,
          categoriesSubtotals = _this$state4.categoriesSubtotals,
          fundExpenseRatios = _this$state4.fundExpenseRatios,
          bracketNames = _this$state4.bracketNames,
          my529AdminAssetFees = _this$state4.my529AdminAssetFees,
          errorMessages = _this$state4.errorMessages; // copy to the next right column

      var updatedMatrix = matrixAllocations;
      var updatedCategoriesSubtotals = [];
      updatedMatrix.forEach(function (category, categoryIndex) {
        return category.forEach(function (fund, fundIndex) {
          updatedMatrix[categoryIndex][fundIndex][bracketIndex] = matrixAllocations[categoryIndex][fundIndex][bracketIndex - 1]; // recalculate subtotals for categories

          updatedCategoriesSubtotals = _this.updateAndGetCategoriesSubtotals(categoryIndex, bracketIndex, updatedMatrix, categoriesSubtotals);
        });
      }); // recalculate totals for all brackets

      var updatedBracketTotals = _this.updateAndGetBracketTotals(bracketIndex, updatedMatrix, updatedCategoriesSubtotals);

      var hasAnyBracketTotalNot100Error = _this.getBracketsTotalsError(updatedBracketTotals); // recalculate expense ratios for each fund


      var updatedEstFundFees = _this.estFundFeesCalculate(updatedMatrix, fundExpenseRatios, bracketNames); // recalculate est total fees


      var updatedEstTotalFees = _this.estTotalFeesCalculate(updatedEstFundFees, my529AdminAssetFees, bracketNames);

      var updatedErrorMessages = _objectSpread(_objectSpread({}, errorMessages), {}, {
        hasAnyBracketTotalNot100Error: hasAnyBracketTotalNot100Error
      });

      _this.setState({
        matrixAllocations: updatedMatrix,
        estFundFees: updatedEstFundFees,
        estTotalFees: updatedEstTotalFees,
        categoriesSubtotals: updatedCategoriesSubtotals,
        bracketTotals: updatedBracketTotals,
        errorMessages: updatedErrorMessages
      }); // pass to the parent if it wants it


      onAllocationChange && onAllocationChange(updatedMatrix, updatedErrorMessages);
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDownAllocationInputHandler", function (event, visibleFundId, bracketIndex) {
      if (event.key === 'Enter') {
        var maxBracketLength = _this.state.matrixAllocations[0][0].length; // the same for all funds

        var maxVisibleFundIdLength = _this.getVisibleFundIdsLength();

        var cellRefById; // Navigate up

        if (event.shiftKey) {
          var upVisibleFundId = visibleFundId - 1; // Can't navigate up if you're on the first visible row of the table

          if (upVisibleFundId >= 0) {
            cellRefById = document.getElementById("input_".concat(upVisibleFundId, "_").concat(bracketIndex)); // also due to the sticky headers make sure it scrolls by offset to show

            var offset = _this.cumulativeOffset(cellRefById) - (_this.subCategoryStickyHeaderOffset + cellRefById.offsetHeight);
            window.scrollTo(0, offset);
          } else if (bracketIndex > 0) {
            // go to the top one bracket left
            cellRefById = document.getElementById("input_".concat(maxVisibleFundIdLength - 1, "_").concat(bracketIndex - 1));
          }
        } // Navigate Down
        else {
          var downVisibleFundId = visibleFundId + 1; // Can't navigate down if you're on the last visible row of the table

          if (downVisibleFundId < maxVisibleFundIdLength) {
            cellRefById = document.getElementById("input_".concat(downVisibleFundId, "_").concat(bracketIndex));
          } else if (bracketIndex < maxBracketLength) {
            // go to the top one bracket left
            cellRefById = document.getElementById("input_".concat(0, "_", bracketIndex + 1));
          }
        }

        if (cellRefById) {
          cellRefById.focus();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleDownloadPdf", function () {
      var element = _this.printRef.current;
      var statementWindow = window.open('', '_blank'); // needs to be outside of async call to work in Safari

      statementWindow.document.write(_loadingAnimations.loadingAnimationHTML); // this will get replaced by generated pdf once the api loads all data    
      // Per html2canvas docs https://html2canvas.hertzen.com/configuration/ we can add "data-html2canvas-ignore" attribute to 
      // selected elements and html2canvas will exclude them from the rendering. 

      (0, _html2canvas["default"])(element).then(function (canvas) {
        var imgData = canvas.toDataURL('image/png');
        var heightOffset = 25;
        var imgWidth = 190;
        var pageHeight = 290;
        var imgHeight = canvas.height * imgWidth / canvas.width;
        var heightLeft = imgHeight;
        var doc = new _jspdf.jsPDF({
          orientation: 'portrait',
          unit: 'mm',
          compress: true // gets file to < 1MB, without this pdf file would go to 40MBs

        });
        var position = 0;
        doc.addImage(imgData, 'PNG', 10, 0, imgWidth, imgHeight + heightOffset, '', 'FAST');
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          doc.addPage();
          doc.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight + heightOffset, '', 'FAST');
          heightLeft -= pageHeight;
        }

        statementWindow.location = doc.output('bloburl'); // appeases Safari where window.open is outside of async call
      })["catch"](function () {
        // show error in a new tab by replacing its html content
        statementWindow.document.close(); // clear first

        statementWindow.document.write(_loadingAnimations.loadingErrorHTML);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSaveHandler", function () {
      _this.setState({
        wasSaveClicked: true
      });

      _this.props.onSave();
    });

    _defineProperty(_assertThisInitialized(_this), "renderShowSelectedFundsButton", function (FundCategories, showSelectedFundsOnly) {
      return _this.wasAnyFundSelected() ? /*#__PURE__*/_react["default"].createElement("span", {
        onClick: function onClick(e) {
          return _this.onSelectedFundsToggleHandler(e, FundCategories);
        },
        className: "calculator_show_selected_funds_enabled"
      }, showSelectedFundsOnly ? 'Show All Funds' : 'Show Selected Funds') : /*#__PURE__*/_react["default"].createElement("span", {
        className: "calculator_show_selected_funds_disabled"
      }, "Show Selected Funds");
    });

    _defineProperty(_assertThisInitialized(_this), "renderSubtotalValues", function (matrixAllocations, categoryIndex) {
      var isStatic = _this.state.isStatic;
      var textAlign = isStatic ? 'center' : 'right';
      return _this.state.bracketNames.map(function (bracket, bracketIndex) {
        return /*#__PURE__*/_react["default"].createElement("td", {
          key: "totals_".concat(bracketIndex, "_").concat(categoryIndex),
          className: "subtotal_value",
          style: {
            textAlign: textAlign
          }
        }, (0, _helpers.toFixed2)(_this.state.categoriesSubtotals[categoryIndex][bracketIndex]), "%");
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderTotalValues", function () {
      return _this.state.bracketNames.map(function (bracket, bracketIndex) {
        return /*#__PURE__*/_react["default"].createElement("td", {
          key: "category_totals_".concat(bracketIndex)
        }, _this.state.bracketTotals[bracketIndex], "%");
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderCategories", function (categories, matrixAllocations, categoriesToShow) {
      var _this$props2 = _this.props,
          isViewing = _this$props2.isViewing,
          isInternalView = _this$props2.isInternalView;
      var _this$state5 = _this.state,
          showSelectedFundsOnly = _this$state5.showSelectedFundsOnly,
          hasFundsValues = _this$state5.hasFundsValues,
          selectedFunds = _this$state5.selectedFunds,
          categoryStickyHeaderOffset = _this$state5.categoryStickyHeaderOffset,
          subCategoryStickyHeaderOffset = _this$state5.subCategoryStickyHeaderOffset,
          categoryColors = _this$state5.categoryColors,
          visibleFundIds = _this$state5.visibleFundIds,
          categoriesSubtotals = _this$state5.categoriesSubtotals,
          isStatic = _this$state5.isStatic;
      var rows = [];
      categories && categories.forEach(function (category, categoryIndex) {
        var categoryKey = "category_".concat(category.FundCategoryId, "_").concat(categoryIndex);

        var showCategory = _this.isCategoryShowing(categoryIndex, categoriesSubtotals);

        if (showCategory) {
          if (!isInternalView) {
            var categoryTitleRowExpandable = /*#__PURE__*/_react["default"].createElement("tr", {
              key: "label_".concat(categoryKey),
              onClick: function onClick() {
                return _this.onCategoryExpendToggleHandler(categoryIndex);
              },
              className: "onclick hideOnPrint",
              "data-html2canvas-ignore": true
            }, /*#__PURE__*/_react["default"].createElement("th", {
              colSpan: "100%",
              className: "category",
              style: {
                top: "".concat(categoryStickyHeaderOffset, "px")
              }
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: "category_label_container"
            }, /*#__PURE__*/_react["default"].createElement("div", null, category.FundCategoryName), !isViewing && /*#__PURE__*/_react["default"].createElement("div", null, categoriesToShow[categoryIndex] ? /*#__PURE__*/_react["default"].createElement(_iconsMaterial.ExpandLess, null) : /*#__PURE__*/_react["default"].createElement(_iconsMaterial.ExpandMore, null)))));

            var categoryTitleRowSimple = /*#__PURE__*/_react["default"].createElement("tr", {
              key: "label_".concat(categoryKey),
              className: "hideOnPrint",
              "data-html2canvas-ignore": true
            }, /*#__PURE__*/_react["default"].createElement("th", {
              colSpan: "100%",
              className: "category",
              style: {
                top: "".concat(categoryStickyHeaderOffset, "px")
              }
            }, /*#__PURE__*/_react["default"].createElement("div", {
              className: "category_label_container"
            }, /*#__PURE__*/_react["default"].createElement("div", null, category.FundCategoryName))));

            isViewing ? rows.push(categoryTitleRowSimple) : rows.push(categoryTitleRowExpandable);
          }

          categoriesToShow[categoryIndex] && rows.push( /*#__PURE__*/_react["default"].createElement(_Category["default"], {
            onKeyDown: _this.onKeyDownAllocationInputHandler,
            visibleFundIds: visibleFundIds,
            isViewing: isViewing,
            isStatic: isStatic,
            isInternalView: isInternalView,
            subCategoryStickyHeaderOffset: subCategoryStickyHeaderOffset,
            categoryColor: categoryColors[categoryIndex],
            categoryKey: categoryKey,
            key: categoryKey,
            funds: category.Funds,
            categoryIndex: categoryIndex,
            showSelectedFundsOnly: showSelectedFundsOnly,
            hasFundsValues: hasFundsValues,
            selectedFunds: selectedFunds,
            matrixAllocations: matrixAllocations,
            getBracketError: _this.getBracketError,
            onBracketValueChangeHandler: _this.onBracketValueChangeHandler,
            onBracketBlurHandler: _this.onBracketBlurHandler,
            onFundSelectionHandler: _this.onFundSelectionHandler
          }));
          !isInternalView && rows.push( /*#__PURE__*/_react["default"].createElement("tr", {
            "data-html2canvas-ignore": true,
            className: "subtotal hideOnPrint",
            key: "subtotal_".concat(categoryKey)
          }, /*#__PURE__*/_react["default"].createElement("td", {
            className: "subtotal_label"
          }, "Subtotal for ", category.FundCategoryName), /*#__PURE__*/_react["default"].createElement("td", null, "\xA0"), _this.renderSubtotalValues(matrixAllocations, categoryIndex)));
        }
      });
      return rows;
    });

    return _this;
  }

  _createClass(CalculatorForm, [{
    key: "estFundFeesCalculate",
    value: function estFundFeesCalculate(matrixAllocations, fundExpenseRatios, bracketNames) {
      var getCalculatedFundFeesTotalPerCategoryAndBracket = function getCalculatedFundFeesTotalPerCategoryAndBracket(categoryFunds, categoryIndex, bracketIndex) {
        return categoryFunds.reduce(function (sum, fundValue, fundIndex) {
          var parsedAllocation = parseFloat(matrixAllocations[categoryIndex][fundIndex][bracketIndex]);
          var fundAllocationForBracket = isNaN(parsedAllocation) ? 0 : parsedAllocation;
          var fundFeeRate = fundExpenseRatios[categoryIndex][fundIndex];
          sum += fundAllocationForBracket / 100 * fundFeeRate;
          return sum;
        }, 0);
      };

      var getCalculatedFundFeesTotalPerBracket = function getCalculatedFundFeesTotalPerBracket(bracketIndex) {
        return matrixAllocations.reduce(function (sum, categoryFunds, categoryIndex) {
          sum += getCalculatedFundFeesTotalPerCategoryAndBracket(categoryFunds, categoryIndex, bracketIndex);
          return sum;
        }, 0);
      };

      return bracketNames.map(function (bracketName, bracketIndex) {
        return getCalculatedFundFeesTotalPerBracket(bracketIndex);
      });
    }
    /********** HANDLERS **********/

  }, {
    key: "renderFooterMessage",
    value: function renderFooterMessage() {
      var _this$state6 = this.state,
          agreementYear = _this$state6.agreementYear,
          isStatic = _this$state6.isStatic;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "calculator_footer_notes hideOnPrint ".concat(isStatic ? 'is_static_margin' : 'is_agebased_margin')
      }, /*#__PURE__*/_react["default"].createElement("p", null, "* An investment allocation to this fund may not exceed 25 percent in the account. Therefore, the total underlying fund expense will reflect the weighted allocation to the underlying investment."), /*#__PURE__*/_react["default"].createElement("p", null, "\u2020 The total underlying fund expense reflects a fee waiver pursuant to a Fee Waiver Agreement in effect through February 28, ", agreementYear, ". The total underlying fund expense may increase if the Fee Waiver Agreement is not extended beyond February 28, ", agreementYear, "."), /*#__PURE__*/_react["default"].createElement("p", null, "Note: All numbers are rounded to the third decimal place."));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
          loading = _this$props3.loading,
          schema = _this$props3.schema;

      if (!loading && schema && Object.keys(schema).length > 0 && schema.FundCategories.length > 0) {
        this.initializeCalculator(schema);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props4 = this.props,
          loading = _this$props4.loading,
          schema = _this$props4.schema;

      if ((prevProps.loading !== loading || prevProps.schema.FundCategories.length !== schema.FundCategories.length) && !loading && this.props.schema && Object.keys(schema).length > 0 && schema.FundCategories.length > 0) {
        this.initializeCalculator(schema);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state7 = this.state,
          showSelectedFundsOnly = _this$state7.showSelectedFundsOnly,
          matrixAllocations = _this$state7.matrixAllocations,
          errorMessages = _this$state7.errorMessages,
          categoriesToShow = _this$state7.categoriesToShow,
          bracketErrorIndices = _this$state7.bracketErrorIndices,
          bracketNames = _this$state7.bracketNames,
          bracketTotals = _this$state7.bracketTotals,
          estFundFees = _this$state7.estFundFees,
          my529AdminAssetFees = _this$state7.my529AdminAssetFees,
          templateName = _this$state7.templateName,
          estTotalFees = _this$state7.estTotalFees,
          categoriesSubtotals = _this$state7.categoriesSubtotals,
          isStatic = _this$state7.isStatic,
          isInitializing = _this$state7.isInitializing,
          wasSaveClicked = _this$state7.wasSaveClicked,
          categoryColors = _this$state7.categoryColors;
      var _this$props5 = this.props,
          isViewing = _this$props5.isViewing,
          stickyHeaderTopOffset = _this$props5.stickyHeaderTopOffset,
          loading = _this$props5.loading,
          onSave = _this$props5.onSave,
          hideTemplateName = _this$props5.hideTemplateName,
          isInternalView = _this$props5.isInternalView,
          schema = _this$props5.schema,
          isTemplateNameEditing = _this$props5.isTemplateNameEditing,
          hidePrintBtn = _this$props5.hidePrintBtn;
      var customizedTemplateName = isStatic ? 'New Customized Static' : 'New Customized Age-Based';
      var templateNameParsed = schema.TemplateName ? schema.TemplateName : customizedTemplateName;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "calculator_container"
      }, isInitializing || loading || !schema || schema.FundCategories.length === 0 ? /*#__PURE__*/_react["default"].createElement(_LoadingOverlay["default"], {
        show: true,
        width: "50vw",
        indicatorHeight: "10px"
      }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !hideTemplateName && /*#__PURE__*/_react["default"].createElement("h1", null, isTemplateNameEditing ? /*#__PURE__*/_react["default"].createElement(_material.TextField, {
        inputProps: {
          style: {
            fontSize: 'x-large'
          }
        },
        onChange: this.onTemplateNameChangeHandler,
        label: "Template Name",
        value: templateName,
        error: wasSaveClicked && Boolean(errorMessages.templateNameNot1To40CharsError),
        helperText: wasSaveClicked ? errorMessages.templateNameNot1To40CharsError : '',
        autoFocus: true
      }) : /*#__PURE__*/_react["default"].createElement("div", null, templateNameParsed)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "table_container",
        ref: this.printRef
      }, /*#__PURE__*/_react["default"].createElement("table", null, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", {
        className: "brackets",
        style: {
          top: "".concat(stickyHeaderTopOffset, "px")
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        "data-html2canvas-ignore": true,
        className: "calculator_header_buttons hideOnPrint"
      }, !isViewing && this.renderShowSelectedFundsButton(schema.FundCategories, showSelectedFundsOnly), !isViewing && /*#__PURE__*/_react["default"].createElement(_IconBtnTooltip["default"], {
        icon: "autorenew",
        onClick: this.resetCalculatorHandler,
        title: "Reset"
      }), !isViewing && onSave && /*#__PURE__*/_react["default"].createElement(_IconBtnTooltip["default"], {
        icon: "save",
        onClick: this.onSaveHandler,
        title: "Save"
      }), !hidePrintBtn && /*#__PURE__*/_react["default"].createElement("div", {
        "data-html2canvas-ignore": true
      }, /*#__PURE__*/_react["default"].createElement(_IconBtnTooltip["default"], {
        icon: "print" // onClick={window.print}
        ,
        onClick: this.handleDownloadPdf,
        title: "Print"
      })))), /*#__PURE__*/_react["default"].createElement("th", {
        className: "brackets brackets_header_label",
        style: {
          top: "".concat(stickyHeaderTopOffset, "px")
        }
      }, !isStatic && 'Ages'), /*#__PURE__*/_react["default"].createElement(_BracketsHeader["default"], {
        isViewing: isViewing,
        stickyHeaderTopOffset: stickyHeaderTopOffset,
        bracketNames: bracketNames,
        onBracketCopyHandler: this.onBracketCopyHandler
      })), /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", null, "Fund Name"), !isInternalView ? /*#__PURE__*/_react["default"].createElement("th", null, "Underlying Fund Expense") : /*#__PURE__*/_react["default"].createElement("th", null), /*#__PURE__*/_react["default"].createElement("th", {
        colSpan: "100%"
      }, "Allocation Percentage"))), /*#__PURE__*/_react["default"].createElement("tbody", null, this.renderCategories(schema.FundCategories, matrixAllocations, categoriesToShow, bracketErrorIndices)), /*#__PURE__*/_react["default"].createElement(_FormTotalsFoot["default"], {
        isInternalView: isInternalView,
        isStatic: isStatic,
        bracketNames: bracketNames,
        bracketTotals: bracketTotals,
        estFundFees: estFundFees,
        my529AdminAssetFees: my529AdminAssetFees,
        estTotalFees: estTotalFees,
        victoryChart: /*#__PURE__*/_react["default"].createElement(_StackedBarChart["default"], {
          categoryColors: categoryColors,
          matrixAllocations: matrixAllocations,
          bracketNames: bracketNames,
          categoriesSubtotals: categoriesSubtotals,
          isStatic: isStatic
        })
      })), /*#__PURE__*/_react["default"].createElement("br", null), " ", /*#__PURE__*/_react["default"].createElement("br", null), " "), !isInternalView && this.renderFooterMessage()));
    }
  }]);

  return CalculatorForm;
}(_react.Component);

exports.CalculatorForm = CalculatorForm;

_defineProperty(CalculatorForm, "propTypes", {
  /****************** REQUIRED ******************/
  stickyHeaderTopOffset: _propTypes["default"].number.isRequired,
  // this is offset from top in pixels for sticky headers
  schema: _propTypes["default"].object.isRequired,
  // it can be static, age-based for new, edit, view, or investment path
  isViewing: _propTypes["default"].bool,
  // this will show only non zero funds with all functionality and buttons except print disabled
  currentDate: _propTypes["default"].oneOfType([// this is to calculate current year for help info below the calculator
  _propTypes["default"].string, _propTypes["default"].instanceOf(Date)]),

  /****************** OPTIONAL ******************/
  loading: _propTypes["default"].bool,
  // you can pass to show loading bar
  isTemplateNameEditing: _propTypes["default"].bool,
  // you can edit template name
  onAllocationChange: _propTypes["default"].func,
  // on each cell input this will return all allocations as 3D matrix and all errors
  onTemplateNameChange: _propTypes["default"].func,
  // on each template name input this will return template name and all errors
  onSave: _propTypes["default"].func,
  // you can pass what happens on click save button
  hideTemplateName: _propTypes["default"].bool,
  // if for some reason the template name needs to be hidden (for example investment path)
  hidePrintBtn: _propTypes["default"].bool,
  // hides print button
  isInternalView: _propTypes["default"].bool // hides footer with graph and totals, text below footer, and all category headers and subheaders

});

_defineProperty(CalculatorForm, "defaultProps", {
  loading: false,
  isViewing: false,
  isTemplateNameEditing: false,
  hideTemplateName: false,
  hidePrintBtn: false,
  isInternalView: false
});

var _default = CalculatorForm;
exports["default"] = _default;